var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "CardChip",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 387.8 380.3",
    style: {
      enableBackground: "new 0 0 387.8 380.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:url(#gold-gradient);stroke:#000;stroke-width:10;stroke-miterlimit:10}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#c79750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#e6b964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#f8e889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#deb15f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#dfb461"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st0",
    d: "M308.8 375.3H79.1C38.2 375.3 5 342.1 5 301.2V79.1C5 38.2 38.2 5 79.1 5h229.7c40.9 0 74.1 33.2 74.1 74.1v222.2c-.1 40.8-33.2 74-74.1 74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M109.9 5.1v370"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M4.9 95.1h105"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M4.9 185.1h105"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M1.9 275.1h105"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M276.9 275.1h105"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M274.9 185.1h105"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M277.9 95.1h105"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    d: "M277.4 90.1h-1c-2.5 0-4.5 2-4.5 4.5v272c0 2.5 2 4.5 4.5 4.5h1c2.5 0 4.5-2 4.5-4.5v-272c0-2.5-2-4.5-4.5-4.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardChip);
export default __webpack_public_path__ + "static/media/CreditCardChip.5bcecc773f21fec32a60020d2b9d4156.svg";
export { ForwardRef as ReactComponent };